import React, { useContext } from 'react';
import moment from 'moment';
import classnames from 'classnames';
import { useParams } from 'react-router-dom';

import './styles.scss';
import { useDataFetch } from '@common/hooks/dataFetch';
import { SportTypesUrls } from '@racings/constants/enums/sportTypes';
import { fetchRequest } from '@common/helpers/util/requestMiddleware';
import { nthNumber } from '@common/helpers/nthNumber';
import { useTranslation } from '@common/hooks/translation';
import OddConverter from '@common/helpers/oddConverter';
import { PreferencesContext } from '@common/contexts/preferences';
import { RacingsContext } from '@racings/store/context';

export const RacingResultGame = ({ game, activeGameId, competitionName }) => {
  const { market } = game;
  const selections = market.Selections || [];
  const [{config}] = useContext(RacingsContext);
  const [{ oddsFormat }] = useContext(PreferencesContext);
  const { sportType } = useParams();
  const t = useTranslation();

  const extraInfo = market.MarketExtraInfo
    ? JSON.parse(market.MarketExtraInfo)
    : null;

  const [racingData] = useDataFetch(
    () => fetchRequest('https://horseracing.betcoapps.com', `rc/${game.id}.json`, 'GET'),
    [],
  );

  return (
    <div key={game.id} className="racing-game-container">
      <div className="info-container">
        <div
          className={classnames('racing-game-info', {
            row: !activeGameId,
          })}
        >
          <div className="region-info info-item">
            <span className={`flag icon-${game.region_alias?.replaceAll(' ', '').toLowerCase()} flag`} />
            {!!racingData?.raceNumber && <span className="competition-name">{t(`R ${racingData?.raceNumber}`)}</span>}
            <span className="competition-name">{t(competitionName)}</span>
          </div>
          {!activeGameId && (
            <div className="game-date info-item">
              {moment.unix(game.start_ts).format('HH:mm - ddd DD MMM')}
            </div>
          )}

          <div className="game-number-wrapper info-item">
            {t('Round Id:')}
            {' '}
            <span>{game.id}</span>
          </div>

          {extraInfo?.EachWayK && extraInfo?.EachWayPlace && (
            <div className="game-number-wrapper info-item">
              {t('Each Way:')}
              {' '}
              <span>
                1/
                {extraInfo.EachWayK}
                {' '}
                {t('Odds')}
                {extraInfo.EachWayPlace}
                {' '}
                {t('Places')}
              </span>
            </div>
          )}
        </div>
      </div>

      <div className="result-events-container">
        <div className="result-racing-event-header-row">
          <span>{t('Place')}</span>
          <span>{t('Number')}</span>
          <span>{sportType === SportTypesUrls.HORSE ? t('Horse') : t('Greyhounds')}</span>
          {sportType === SportTypesUrls.HORSE && <span>{t('Trainer/Jockey')}</span>}
          <span>{t('Odd')}</span>
        </div>
        <div className="result-racing-event-row">
          {
            selections.sort((a, b) => {
              if (a.Position !== 0 && b.Position !== 0) {
                return a.Position - b.Position;
              }
              if (a.Position !== 0) {
                return -1;
              }
              if (b.Position !== 0) {
                return 1;
              }
              return 0;
            }).map((item, index) => {
              const parsedData = racingData?.selections?.filter((re) => re.name === item.Name);
              const imgData = parsedData && parsedData[0]?.jockeyInfo?.coloursFilename;
              const jockeyName = parsedData && parsedData[0]?.jockeyInfo?.name;
              const trainerName = parsedData && parsedData[0]?.trainerInfo?.name;
              const {
                weightPounds, weightStones, formFigures, age,
              } = (parsedData && parsedData[0]) || {};

              return (
                <div key={index} className={`result-info-wrapper ${sportType === SportTypesUrls.GREYHOUNDS ? 'greyHonds' : ''}`}>
                  <div className="position">
                    {
                      item.Position === 0 ? 'NR' : item.Position <= 40 ? nthNumber(item.Position) : '-'
                    }
                  </div>
                  <div className="runner-number">
                    {' '}
                    <span>{item.Order}</span>
                    {' '}
                  </div>
                  <div className="horse">
                    {imgData && <img alt="shirt-img" src={imgData} />}
                    <div>
                      <span>
                        {' '}
                        {item.Name}
                      </span>
                      {imgData && weightPounds && (
                        <div className="horse-info">
                          <span>
                            {t('Age: ')}
                            {' '}
                            <span>{age}</span>
                            {' '}
                          </span>
                          <span>
                            {t('Weight: ')}
                            {' '}
                            <span>
                              {weightPounds}
                              -
                              {weightStones}
                            </span>
                          </span>
                          <span>
                            {t('Form: ')}
                            <span>{formFigures}</span>
                          </span>
                        </div>
                      )}
                    </div>
                  </div>
                  {sportType === SportTypesUrls.HORSE && (
                    <div className="trainer-jokey">
                      {trainerName && jockeyName && (
                        <>
                          <span>
                            T:
                            {t(trainerName)}
                          </span>
                          <span>
                            {' '}
                            J:
                            {t(jockeyName)}
                          </span>
                        </>
                      )}
                    </div>
                  )}
                  <div className="result-odd">{OddConverter(config, item.SPPrice, oddsFormat) || '-'}</div>
                </div>
              );
            })
          }
        </div>
      </div>
    </div>
  );
};
